<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
        </div>
      </div>
      <!-- Add button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes(`${permission}.add`)"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('action.add')"
          @click="$router.push(`/${module}/add`)"
          icon-right="add"
        />
        <q-btn v-if="$store.state.meStore.me.rights.includes(`${permission}.delete`)"
          class="capitalize ctrl-button bg-ctrl-grey right q-mr-md"
          color="ctrl-turquoise"
          :disabled="!rowSelection.length"
          :label="$store.state.stringsStore.strings.list.actions.label"
          :class="{ 'button-active': rowSelection.length }">
            <q-icon size="large" name="mdi-chevron-down"/>
            <i v-show="rowSelection.length" class="counter">{{rowSelection.length}}</i>
            <!-- Direct child of target -->
            <q-popover anchor="bottom middle" self="top middle">
              <q-list link>
                <q-item
                  :class="{ 'disabled': !rowSelection.length }"
                  class="toolbar-list-item" @click.native="removeRows('spare-part-categories')">
                  <q-icon color="positive" size="large" name="delete"/>
                  {{$store.state.stringsStore.strings.action.remove}}
                </q-item>
              </q-list>
            </q-popover>
        </q-btn>
      </div>
    </div>
    <!-- Data table -->
    <table-overview
      :endpoint="endpoint"
      responseFormat="categories"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="selectable">
    </table-overview>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import common from './common';

export default {
  mixins: [
    filtersMixin,
    common,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      rowSelection: [],
      selectable: true,
      isLoading: false,
      columns: [
        {
          name: 'label',
          title: 'Label',
          sortField: 'label',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,

    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },

  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
